import { db } from '../firebaseConfig';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

/**
 * Bir kullanıcıya uygulama içi bildirim gönderir.
 * notifications/{recipientId}/items koleksiyonuna yazar.
 *
 * payload: { type, fromId, fromName, fromPhoto, fromUsername?, targetId?, text? }
 *  - type: 'follow' | 'like' | 'comment'
 */
export async function pushNotification(recipientId, payload) {
    if (!recipientId) return;
    // Kendine bildirim gönderme
    if (payload && payload.fromId && payload.fromId === recipientId) return;

    try {
        await addDoc(collection(db, 'notifications', recipientId, 'items'), {
            read: false,
            createdAt: serverTimestamp(),
            ...payload,
        });
    } catch (e) {
        console.error('Bildirim gönderilemedi:', e);
    }
}

export function timeAgo(date) {
    if (!date) return '';
    const d = typeof date.toDate === 'function' ? date.toDate() : new Date(date);
    const diff = Math.floor((Date.now() - d.getTime()) / 1000);
    if (diff < 60) return 'az önce';
    if (diff < 3600) return `${Math.floor(diff / 60)} dk önce`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} sa önce`;
    if (diff < 604800) return `${Math.floor(diff / 86400)} gün önce`;
    return d.toLocaleDateString('tr-TR');
}
